import { routeConstants } from '@/utils';

/** How long the logout route's goodbye stays up, at the least: the revoke runs under it rather than after it. */
export const GOODBYE_MS = 2000;

/**
 * The history state `main.ts`'s `onSessionExpired` sends to the logout route. `sessionExpired` tells
 * `Logout.vue` the API has already refused the key, so it clears it without asking the API to revoke
 * it (ENG-10329); every other way onto the route is a sign-out the person started, which revokes.
 */
const SESSION_EXPIRED_LOGOUT = {
  message: 'Logging you out because of the expired session, please login again!',
  sessionExpired: true
};

/** Where `onSessionExpired` sends an expired session: the logout route, carrying that state. */
export const SESSION_EXPIRED_LOGOUT_ROUTE = {
  name: routeConstants.LOGOUT.name,
  state: SESSION_EXPIRED_LOGOUT
};

export const isSessionExpiredLogout = (state: unknown): boolean =>
  (state as { sessionExpired?: unknown } | null)?.sessionExpired === true;
